module.exports = __webpack_public_path__ + "img/boom.669c4567.png";